<template>
  <div id="buy" class="buy">
    <div class="buy_title">{{ $t('home.buy.title') }}</div>
    <div class="buy_cont">
      <img class="buy_left" v-lazy="buy_img" alt="">
      <div class="buy_right">
        <div class="buy_right_li">
          <div class="li_title">{{ $t('home.buy.step1') }}</div>
          <div class="li_text">{{ $t('home.buy.step1_text') }}</div>
        </div>
        <div class="buy_right_li">
          <div class="li_title">{{ $t('home.buy.step2') }}</div>
          <div class="li_text">{{ $t('home.buy.step2_text') }}</div>
        </div>
        <div class="buy_right_li">
          <div class="li_title">{{ $t('home.buy.step3') }}</div>
          <div class="li_text">{{ $t('home.buy.step3_text') }}</div>
        </div>
      </div>
    </div>
    <div class="buy_btns">
      <a href="https://t.me/deeplinkglobal" target="_blank" class="buy_btn"><img class="icon" src="../assets/buy/buy_icon1.png" alt=""> {{ $t('home.buy.btn1') }}</a>
      <!-- <div class="buy_btn" @click="scrollToAnchor"><img class="icon" src="../assets/buy/buy_icon2.png" alt=""> {{ $t('home.buy.btn2') }}</div> -->
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  import buy_img from "@/assets/buy/buy_img.png"
  export default defineComponent({
    name: 'buy',
    setup() {
      const { t, locale } = useI18n()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const scrollToAnchor = () => {
        const element = document.getElementById("deeplink");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
      return {
        lan,
        buy_img,
        scrollToAnchor
      };
    }
  })
</script>

<style scoped lang="scss">
.buy {
  width: 1200px;
  padding: 30px 40px;
  border-radius: 20px;
  margin: 60px auto;
  box-sizing: border-box;
  background: linear-gradient(86.6deg, rgba(47, 67, 55, 0.612) 5.45%, rgba(46, 81, 60, 0.27) 97.19%);
  .buy_title {
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    text-align: center;
    margin-bottom: 24px;
    letter-spacing: 0.05em;
  }
  .buy_cont {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .buy_left {
      display: inline-block;
      width: 364px;
      // height: 240px;
      margin-right: 50px;
      border-radius: 10px;
    }
    .buy_right {
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      .buy_right_li {
        font-size: 16px;
        line-height: 26px;
        letter-spacing: 0em;
        margin-bottom: 30px;
        color: rgba(255, 255, 255, 0.88);
        &:last-child {
          margin-bottom: 0;
        }
        .li_title {
          font-weight: 600;
        }
        .li_text {
          font-weight: 400;
        }
      }
    }
  }
  .buy_btns {
    width: 100%;
    display: flex;
    margin-top: 30px;
    align-items: center;
    justify-content: flex-end;
    .buy_btn {
      display: flex;
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;
      line-height: 21px;
      margin-left: 30px;
      padding: 15px 60px;
      letter-spacing: 0em;
      border-radius: 60px;
      align-items: center;
      text-decoration: none;
      color: rgba(3, 255, 145, 1);
      background: rgba(43, 84, 64, 0.96);
      .icon {
        width: 24px;
        height: 24px;
        margin-right: 10px;
        display: inline-block;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .buy {
    width: 90%;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
    .buy_cont {
      display: flex;
      flex-direction: column;
      .buy_left {
        width: 100%;
        height: 100%;
        margin-right: 0px;
        margin-bottom: 20px;
      }
      .faqs_right {
        width: 100%;
        height: 252px;
        .right_cont {
          width: 558px;
          height: 200px;
          .right_ques {
            width: 575px;
            height: 200px;
          }
        }
      }
    }
    .buy_btns {
      .buy_btn {
        padding: 10px 30px;
      }
    }
  }
}
</style>